function normalizePortugueseVat(value) {
  const normalizedValue = `${value || ''}`.trim().toUpperCase()

  return normalizedValue.startsWith('PT') ? normalizedValue.slice(2) : normalizedValue
}

export function shouldRequireOrganizationField(country, vat) {
  const normalizedCountry = `${country || ''}`.trim().toUpperCase()
  const normalizedVat = normalizePortugueseVat(vat)

  return normalizedCountry === 'PT' && (normalizedVat.startsWith('5') || normalizedVat.startsWith('6'))
}

export function requiresProofOfAddress(country, vat, commercialRegistrationQueryCode) {
  return !shouldRequireOrganizationField(country, vat) || !`${commercialRegistrationQueryCode || ''}`.trim()
}

export function validateCommercialRegistrationQueryCode(value) {
  return /^\d{4}-\d{4}-\d{4}$/.test(`${value || ''}`.trim())
}

export function validateZipcode(country, zipcode) {
  const normalizedCountry = `${country || ''}`.trim().toUpperCase()

  return normalizedCountry !== 'PT' || /^\d{4}-\d{3}$/.test(`${zipcode || ''}`.trim())
}

export function validateNIF(nif) {
  const normalizedNif = normalizePortugueseVat(nif)
  const validationSets = {
    one: ['1', '2', '3', '5', '6', '8'],
    two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99'],
  }

  if (normalizedNif.length !== 9) {
    return false
  }

  if (!validationSets.one.includes(normalizedNif.substring(0, 1)) && !validationSets.two.includes(normalizedNif.substring(0, 2))) {
    return false
  }

  const nifNumbers = normalizedNif.split('').map((character) => Number.parseInt(character, 10))
  const total =
    nifNumbers[0] * 9 +
    nifNumbers[1] * 8 +
    nifNumbers[2] * 7 +
    nifNumbers[3] * 6 +
    nifNumbers[4] * 5 +
    nifNumbers[5] * 4 +
    nifNumbers[6] * 3 +
    nifNumbers[7] * 2
  const modulo11 = total % 11
  const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11

  return checkDigit === Number(normalizedNif[8])
}
